<template>
  <div class="columns is-1 topics_container has-text-white">
    <div class="column topic" v-for="topic in selectedSampleTopics" :class="get_topic_class(topic)">
      {{topic}}
    </div>
  </div>
</template>

<script setup>
import { inject } from 'vue';

const cps_supplement_topics = inject('cps_supplement_topics');
const selectedSampleTopics = inject('selectedSampleTopics');

const get_topic_class = (supplement_topic) => {
  const i = cps_supplement_topics.value[supplement_topic]?.index || 0;
  return "supplement_topic_"+(i+1);
}

</script>

<style lang="scss" scoped>

.columns.topics_container {
  min-height: 29px;
  margin: 0;
}

.topic {
  font-size: 14px;
  margin-top: 5px;
  padding: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 19.5px;
}
</style>
